module.exports = __webpack_public_path__ + "img/air_hum.65154207.svg";